<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <tamanio-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import TamanioShowData from "./TamanioShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "TamanioShow",
        components: {CrudShow, TamanioShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'tamanio.showing',
            }
        },
    }
</script>

